import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'gatsby';
import kebabCase from 'lodash/kebabCase';

export const Category = ({name}) => <Link to={`/blog/categories/${kebabCase(name)}`}>{name}</Link>;
Category.propTypes = { name: PropTypes.string.isRequired };